
function Header(){
  return(
    <div className="container-fluid shadow " id="brand_name">
      <div className="row brand_flex_cont ">
        <div className="col-lg-6 brand_surname_container d-flex justify-content-center justify-content-lg-end ">
        <h1 id="brand_title">Asta Remeikiene </h1>
      </div>
      <div className="col-lg-6 brand_title_container d-flex justify-content-center justify-content-lg-start">
          <h1 id="brand_subtitle">Front-end Web Developer</h1>
      </div>
    </div>
  
</div>

  )
}

export default Header;


